/**
 * Created by qlong on 9/12/2016.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux'
import chroma from 'chroma-js';
import { NotificationContainer,NotificationManager } from 'react-notifications'
import { addCategory, removeCategory, setSelectedOption, setAttributes, addAttributes, deleteCategoryColor,
    setCategoryColor, addCategoryColorSet, popCategoryColorSet,setFirstLoadFalse } from '../actions/filterActions'
import { setColor, deleteColor, addVisibleIndexes, removeVisibleIndexes, addColorSet } from '../actions/filterGridAction'
import ListOption from '../components/ListOption'
import Helper from '../Helper'

@connect((store) => {
    return{
        fileData: store.fileData,
        filters: store.filters,
        filterGrid: store.filterGrid,
        filteredLineChart: store.filteredLineChart,
    }
})
export default class Filters extends Component{
    //Get index array based on checked value
    getIndexArray({values, value, existedIndexArray=[]}){
        let indexArray =  []
        const nameIndex = value.split('@')[0]
        const checkBoxValue = value.split('@')[1]

        if (existedIndexArray.length > 0) {
            existedIndexArray.forEach((index) => {
                if(values[nameIndex][index] == checkBoxValue)
                    indexArray.push(index)
            })
        } else {
            values[nameIndex].forEach((v,index) => {
                if(v == checkBoxValue)
                    indexArray.push(index)
            })
        }
        return indexArray
    }

    //Assign shade colors to sorted distinct values of Shade by
    getShadeGroup(visibleIndexes,categoryValues,catNameIndex,catValue,primaryValues,shadeBy,catColor){
        let shadeGroup = {}
        let shadeSet=[]
        // Get how many levels to get shaded
        visibleIndexes.forEach((index) => {
            if (categoryValues[catNameIndex][index] == catValue) {
                shadeSet.push(primaryValues[shadeBy][index])
            }
        })
        shadeSet = Array.from([...new Set(shadeSet)]).sort((a, b) => a - b)
        // Padding to avoid color to be black
        const paddingNum = shadeSet.length/3
        const newColorSet = chroma.bezier([catColor, 'black']).scale().mode('lab').colors(shadeSet.length + paddingNum)
        newColorSet.forEach((c,i) => {
            if ( i < newColorSet.length - paddingNum)
                shadeGroup[shadeSet[i]] = c
        })

        return shadeGroup
    }


    //On category checkbox change
    categoryChange(changedValue,categoryValues,categories,primaryValues,visibleIndexes,categoryColors,attributeValues
        ,chart,e,chartData){
        const isSelected = !categories.includes(changedValue)
        const { categoryColorSet } = this.props.filters
        const { colorSetStatic,colors } = this.props.filterGrid
        if (isSelected && categoryColorSet.length == 0 ) {
            NotificationManager.error('Only 5 categories can be displayed at a time. Please unselect series ' +
                'before selecting new ones.', 'Error: Too many categories selected', 3000);
            e.target.checked = false
            return
        }

        const { selectedOption } = this.props.filters
        const newColor = categoryColorSet[0]
        let existedIndexArray = []
        let existedAttributes = []
        //Get changed indexes based on current category selection
        const changedIndexArray = this.getIndexArray({values: categoryValues, value: changedValue})

        //Calculate existed indexes based on what categories are selected and unselected
        const existedCategories = isSelected? categories : categories.filter((cat) => cat != changedValue)
        existedCategories.forEach((cat) =>{
            existedIndexArray = existedIndexArray.concat(this.getIndexArray({values: categoryValues, value: cat}))
        })
        existedIndexArray = Array.from([...new Set(existedIndexArray)])

        //Calculate available attributes based calculated existed indexes, user selection for the filter will be reset
        existedIndexArray.forEach((index) => {
            attributeValues.forEach((values,i) => existedAttributes.push(i + '@' + values[index]))
        })

        //Update state and draw chart
        if(isSelected){ //select action
            const selectedCatNameIndex = changedValue.split('@')[0]
            const selectedCatValue = changedValue.split('@')[1]
            const shadeGroup = this.getShadeGroup(changedIndexArray,categoryValues,selectedCatNameIndex,selectedCatValue,
                primaryValues,selectedOption,newColor)

            //Pop one color from categoryColorSet for the new category
            this.props.dispatch(popCategoryColorSet())
            //Add category color to categoryColors
            this.props.dispatch(setCategoryColor(changedValue,newColor))
            //Add selected category to state
            this.props.dispatch(addCategory(changedValue))

            //Draw new series and change the color for existed ones based on changed indexes
            changedIndexArray.forEach((index) => {
                const shadeColor =  shadeGroup[primaryValues[selectedOption][index]]
                // Add the current line color to colors state
                this.props.dispatch(setColor(index,shadeColor))

                //If series existed from previous category selection or manual selection
                if (existedIndexArray.includes(index) || visibleIndexes.includes(index)){
                    Helper.updateLineChart({chart: chart, index: index, color: shadeColor, action: "changeColor"})
                    if (colorSetStatic.includes(colors[index])){
                        this.props.dispatch(addColorSet(colors[index]))
                    }
                }
                else { //series never existed
                    this.props.dispatch(addVisibleIndexes(index))
                    Helper.updateLineChart({chart: chart, index: index, color: shadeColor, action: "add",chartData: chartData})
                }
                // Add available attributes based on calculated changed Indexes
                attributeValues.forEach((values,i) => existedAttributes.push(i + '@' + values[index]))
            })

            //Add checked attributes
            this.props.dispatch(addAttributes(existedAttributes))

        } else { //unselect action
            //Add category color back to categoryColorSet for next use
            this.props.dispatch(addCategoryColorSet(categoryColors[changedValue]))
            //Remove category color from categoryColors
            this.props.dispatch(deleteCategoryColor(changedValue,categoryColors[changedValue]))
            //Remove selected category from state
            this.props.dispatch(removeCategory(changedValue))
            //Reset checked attributes
            existedAttributes = Array.from([...new Set(existedAttributes)])
            this.props.dispatch(setAttributes(existedAttributes))

            // Calculate indexes that should be changed color instead remove because of existed previous selected category
            let revertIndexArray = changedIndexArray.filter((i) => existedIndexArray.includes(i))
            // If there are unselected indexes included in previous selected category
            existedCategories.forEach((cat) =>{
                if (revertIndexArray.length > 0) {
                    const catNameIndex = cat.split('@')[0]
                    const catValue = cat.split('@')[1]
                    const catColor = categoryColors[cat]? categoryColors[cat] : newColor
                    const shadeGroup = this.getShadeGroup(existedIndexArray,categoryValues,catNameIndex,catValue,
                        primaryValues,selectedOption,catColor)

                    revertIndexArray.forEach((index,i) => {
                        if (categoryValues[catNameIndex][index] == catValue){
                            const shadeColor = shadeGroup[primaryValues[selectedOption][index]]
                            if (!visibleIndexes.includes(index)){
                                this.props.dispatch(addVisibleIndexes(index))
                            }
                            this.props.dispatch(setColor(index, shadeColor))
                            Helper.updateLineChart({chart: chart, index: index, color: shadeColor, action: "changeColor"})
                        }
                    })
                }
            })


            // If index not included in previous selected category, remove the line from chart
            changedIndexArray.filter((i) => !existedIndexArray.includes(i)).forEach((index) => {
                this.props.dispatch(removeVisibleIndexes(index))
                this.props.dispatch(deleteColor(index))
                Helper.updateLineChart({chart: chart, index: index, action: "delete"})
            })
        }

        //Reset series visibility to true when category change
        if (categories.length > 0) {
            for (let i = 0; i < chart.series.length; i++) {
                if (! chart.series[i].visible){
                    chart.series[i].setVisible(true, false);
                    this.props.dispatch(addVisibleIndexes(chart.series[i].options.id))
                }
            }
        }

        //Redraw chart
        chart.redraw();
    }

    //On filter checkbox change
    filterChange(changedValue,categoryValues,categories,visibleIndexes,attributeValues,chart,e){
        const { attributes } = this.props.filters
        const isSelected = !attributes.includes(changedValue)
        let existedAttributes = []
        if (categories.length == 0 ) {
            NotificationManager.error('Please select category first.', 'Error: No category selected', 3000);
            e.target.checked = false
            return
        }
        if (isSelected) { //select action
            // Calculate available indexes based on selected categories
            let existedIndexArray = []
            categories.forEach((cat) =>{
                existedIndexArray = existedIndexArray.concat(this.getIndexArray({values: categoryValues, value: cat}))
            })
            existedIndexArray = Array.from([...new Set(existedIndexArray)])

            // Calculate changed indexes based on attributes selected within the AVAILABLE indexes
            const changedIndexArray = this.getIndexArray({values: attributeValues, value: changedValue, existedIndexArray:existedIndexArray})
            changedIndexArray.forEach((index) => {
                // Add index to visible sereis
                this.props.dispatch(addVisibleIndexes(index))
                //Add corresponding attributes based on attribute selected
                attributeValues.forEach((values,i) => existedAttributes.push(i + '@' + values[index]))
                // Show the line in the chart
                Helper.updateLineChart({chart: chart, index: index, action: "show"})
            })

            // Add corresponding attributes to state based on attribute selected
            this.props.dispatch(addAttributes(existedAttributes))

        } else { //unselect action
            // Calculate changed indexes based on attributes selected within the VISIBLE indexes
            const changedIndexArray = this.getIndexArray({values: attributeValues, value: changedValue,
                existedIndexArray: visibleIndexes})

            //For all indexes included by this filter, hide the chart
            changedIndexArray.forEach((index) => {
                this.props.dispatch(removeVisibleIndexes(index))
                Helper.updateLineChart({chart: chart, index: index, action: "hide"})
            })

            // Reset attributes state based on unselected attribute
            const existedIndexArray = visibleIndexes.filter((i) => !changedIndexArray.includes(i))
            existedIndexArray.forEach((index) => {
                attributeValues.forEach((values,i) => existedAttributes.push(i + '@' + values[index]))
            })
            this.props.dispatch(setAttributes(existedAttributes))
        }

        // Redraw chart
        chart.redraw();
    }

    //On shade dropdown change
    shadeChange(changedValue,categoryValues,categories,visibleIndexes,primaryValues,categoryColors, chart){
        categories.forEach((cat) =>{
            const catNameIndex = cat.split('@')[0]
            const catValue = cat.split('@')[1]
            const shadeGroup = this.getShadeGroup(visibleIndexes,categoryValues,catNameIndex,catValue,
                primaryValues,changedValue,categoryColors[cat])

            visibleIndexes.forEach((index) => {
                if (categoryValues[catNameIndex][index] == catValue) {
                    const shadeColor = shadeGroup[primaryValues[changedValue][index]]
                    this.props.dispatch(setColor(index, shadeColor))
                    Helper.updateLineChart({chart: chart, index: index, color: shadeColor, action: "changeColor"})
                }
            })
        })

        // Update shade by state
        this.props.dispatch(setSelectedOption(changedValue))
        chart.redraw();
    }

    componentDidUpdate (){
        const { firstLoad } = this.props.filters
        const { chart } = this.props.filteredLineChart
        if (firstLoad == true && Object.keys(chart).length > 0){
            const { categories, categoryColors } = this.props.filters
            const { chartData } = this.props.fileData
            const { visibleIndexes } = this.props.filterGrid
            const categoryValues = chartData.categories.values
            const attributeValues = chartData.attributes.values
            const primaryValues = this.props.fileData.chartData.primary.values
            const vizJsonData = require('../../data/visualizationLibrary.json');
            const pathname = this.props.path
            const defaultCategory = vizJsonData.visualizations.filter((viz) => (viz.routeName == pathname || pathname == ""))[0].defaultCategory
            this.categoryChange(defaultCategory == ""? "0@" + categoryValues[0][0]: defaultCategory,categoryValues,categories,primaryValues,visibleIndexes,categoryColors,
                attributeValues,chart,null,chartData)

            this.props.dispatch(setFirstLoadFalse())
        }
    }


    //Handle category, filter and shade by change
    changeFilter(changedValue, title, e) {
        const { categories, categoryColors } = this.props.filters
        const { visibleIndexes } = this.props.filterGrid
        const { chartData } = this.props.fileData
        const categoryValues = chartData.categories.values
        const attributeValues = chartData.attributes.values
        const primaryValues = this.props.fileData.chartData.primary.values
        const { chart } = this.props.filteredLineChart

        switch (title){
            //Category Change
            case  "Category": {
                this.categoryChange(changedValue,categoryValues,categories,primaryValues,visibleIndexes,categoryColors,
                    attributeValues,chart,e,chartData)
                break
            }
            //Filter Change
            case "Filters":{
                this.filterChange(changedValue,categoryValues,categories,visibleIndexes,attributeValues,chart,e)
                break
            }
            //Shade change
            case "Shade by":{
                this.shadeChange(changedValue,categoryValues,categories,visibleIndexes,primaryValues,categoryColors,chart)
                break
            }
        }
    }

    render(){
        const { chartData } = this.props.fileData
        if (Object.keys(chartData).length > 0) {
            const { filters } = this.props

            return(
                <div >
                    <div className="listOptionFilter">
                        <ListOption title="Category" name="Category" text={chartData.categories} isMulti={true} filters={filters.categories}
                                    onChangeFunction={this.changeFilter.bind(this)}/>
                        <div className="inlineBlock paddingLeft"></div>
                        <ListOption title="Filters" name="Filters" text={chartData.attributes} isMulti={true} filters={filters.attributes}
                                    onChangeFunction={this.changeFilter.bind(this)}/>
                        <div className="inlineBlock paddingLeft"></div>
                        <ListOption title="Shade by" name="Primary" text={chartData.primary} filters={filters.selectedOption}
                                    onChangeFunction={this.changeFilter.bind(this)} />
                    </div>
                    <NotificationContainer/>
                </div>
            )
        } else {
            return (<div></div>)
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/containers/Filter.js
 **/